var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      margin: "auto"
    },
    width: 100,
    height: 100,
    preserveAspectRatio: "xMidYMid",
    display: "block",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.452,
    cy: 67.632,
    r: 2.899,
    fill: "#bdc0c5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-0.5s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    keyTimes: "0;0.5;1",
    values: "32;68;32",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0s",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    keyTimes: "0;0.5;1",
    values: "#bdc0c5;#3b1cd8;#bdc0c5",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-0.5s"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.452,
    cy: 32.367,
    r: 3.101,
    fill: "#bdc0c5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-1.5s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    keyTimes: "0;0.5;1",
    values: "32;68;32",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-1s",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    keyTimes: "0;0.5;1",
    values: "#bdc0c5;#3b1cd8;#bdc0c5",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-0.5s"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.129,
    cy: 62.907,
    r: 2.659,
    fill: "#bdc0c5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-0.7s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    keyTimes: "0;0.5;1",
    values: "32;68;32",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-0.2s",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    keyTimes: "0;0.5;1",
    values: "#bdc0c5;#3b1cd8;#bdc0c5",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-0.7s"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.129,
    cy: 37.093,
    r: 3.341,
    fill: "#bdc0c5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-1.7s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    keyTimes: "0;0.5;1",
    values: "32;68;32",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-1.2s",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    keyTimes: "0;0.5;1",
    values: "#bdc0c5;#3b1cd8;#bdc0c5",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-0.7s"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.806,
    cy: 51.138,
    r: 2.419,
    fill: "#bdc0c5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-0.9s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    keyTimes: "0;0.5;1",
    values: "32;68;32",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-0.4s",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    keyTimes: "0;0.5;1",
    values: "#bdc0c5;#3b1cd8;#bdc0c5",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-0.9s"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.806,
    cy: 48.862,
    r: 3.581,
    fill: "#bdc0c5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-1.9s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    keyTimes: "0;0.5;1",
    values: "32;68;32",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-1.4s",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    keyTimes: "0;0.5;1",
    values: "#bdc0c5;#3b1cd8;#bdc0c5",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-0.9s"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.484,
    cy: 38.479,
    r: 2.621,
    fill: "#bdc0c5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-1.1s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    keyTimes: "0;0.5;1",
    values: "32;68;32",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-0.6s",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    keyTimes: "0;0.5;1",
    values: "#bdc0c5;#3b1cd8;#bdc0c5",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-1.1s"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.484,
    cy: 61.521,
    r: 3.379,
    fill: "#bdc0c5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-2.1s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    keyTimes: "0;0.5;1",
    values: "32;68;32",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-1.6s",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    keyTimes: "0;0.5;1",
    values: "#bdc0c5;#3b1cd8;#bdc0c5",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-1.1s"
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.161,
    cy: 32.717,
    r: 2.861,
    fill: "#bdc0c5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-1.3s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    keyTimes: "0;0.5;1",
    values: "32;68;32",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-0.8s",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    keyTimes: "0;0.5;1",
    values: "#bdc0c5;#3b1cd8;#bdc0c5",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-1.3s"
  }))), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.161,
    cy: 67.283,
    r: 3.139,
    fill: "#bdc0c5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-2.3s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    keyTimes: "0;0.5;1",
    values: "32;68;32",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-1.8s",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    keyTimes: "0;0.5;1",
    values: "#bdc0c5;#3b1cd8;#bdc0c5",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-1.3s"
  }))), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.839,
    cy: 32.367,
    r: 3.101,
    fill: "#bdc0c5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-1.5s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    keyTimes: "0;0.5;1",
    values: "32;68;32",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-1s",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    keyTimes: "0;0.5;1",
    values: "#bdc0c5;#3b1cd8;#bdc0c5",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-1.5s"
  }))), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.839,
    cy: 67.632,
    r: 2.899,
    fill: "#bdc0c5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-2.5s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    keyTimes: "0;0.5;1",
    values: "32;68;32",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-2s",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    keyTimes: "0;0.5;1",
    values: "#bdc0c5;#3b1cd8;#bdc0c5",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-1.5s"
  }))), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.516,
    cy: 37.093,
    r: 3.341,
    fill: "#bdc0c5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-1.7s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    keyTimes: "0;0.5;1",
    values: "32;68;32",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-1.2s",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    keyTimes: "0;0.5;1",
    values: "#bdc0c5;#3b1cd8;#bdc0c5",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-1.7s"
  }))), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.516,
    cy: 62.907,
    r: 2.659,
    fill: "#bdc0c5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-2.7s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    keyTimes: "0;0.5;1",
    values: "32;68;32",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-2.2s",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    keyTimes: "0;0.5;1",
    values: "#bdc0c5;#3b1cd8;#bdc0c5",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-1.7s"
  }))), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.194,
    cy: 48.862,
    r: 3.581,
    fill: "#bdc0c5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-1.9s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    keyTimes: "0;0.5;1",
    values: "32;68;32",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-1.4s",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    keyTimes: "0;0.5;1",
    values: "#bdc0c5;#3b1cd8;#bdc0c5",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-1.9s"
  }))), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.194,
    cy: 51.138,
    r: 2.419,
    fill: "#bdc0c5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-2.9s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    keyTimes: "0;0.5;1",
    values: "32;68;32",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-2.4s",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    keyTimes: "0;0.5;1",
    values: "#bdc0c5;#3b1cd8;#bdc0c5",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-1.9s"
  }))), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.871,
    cy: 61.521,
    r: 3.379,
    fill: "#bdc0c5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-2.1s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    keyTimes: "0;0.5;1",
    values: "32;68;32",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-1.6s",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    keyTimes: "0;0.5;1",
    values: "#bdc0c5;#3b1cd8;#bdc0c5",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-2.1s"
  }))), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.871,
    cy: 38.479,
    r: 2.621,
    fill: "#bdc0c5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-3.1s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    keyTimes: "0;0.5;1",
    values: "32;68;32",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-2.6s",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    keyTimes: "0;0.5;1",
    values: "#bdc0c5;#3b1cd8;#bdc0c5",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-2.1s"
  }))), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.548,
    cy: 67.283,
    r: 3.139,
    fill: "#bdc0c5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-2.3s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    keyTimes: "0;0.5;1",
    values: "32;68;32",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-1.8s",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    keyTimes: "0;0.5;1",
    values: "#bdc0c5;#3b1cd8;#bdc0c5",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-2.3s"
  }))), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.548,
    cy: 32.717,
    r: 2.861,
    fill: "#bdc0c5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-3.3s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    keyTimes: "0;0.5;1",
    values: "32;68;32",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-2.8s",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    keyTimes: "0;0.5;1",
    values: "#bdc0c5;#3b1cd8;#bdc0c5",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-2.3s"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.761cf5a7c443318866e4927252f93589.svg";
export { ForwardRef as ReactComponent };